import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { admin, loginRoutingModule } from '../authentication/login/login.routes';
import { recoveryRoutingModule } from '../authentication/recovery/recovery.routes';
import { registerRoutingModule } from '../authentication/register/register.routes';
import { securityCodeRoutingModule } from '../authentication/security-code/security-code.routes';
import { newPasswordRoutingModule } from '../authentication/new-password/new-password.routes';

export const auth: Routes = [
  {
    path: 'auth',
    children: [
      ...loginRoutingModule.routes,
      ...recoveryRoutingModule.routes,
      ...registerRoutingModule.routes,
      ...securityCodeRoutingModule.routes,
      ...newPasswordRoutingModule.routes
    ],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(admin)],
  exports: [RouterModule],
})
export class AuthRoutingModule {
  static routes = admin;
}
